// extracted by mini-css-extract-plugin
export default {"navWrapper":"Navigation_navWrapper__qPpQn","nav":"Navigation_nav__7WdPp"};